<div class="row">
    <div class="col-12">

        <div class="card">
            <div class="modal-header">
                <span class="modal-header-title">{{ 'TEMPLATES.TEMPLATES_LIST' | translate }}</span>
                <button type="button" class="btn btn-primary btn-sm" [disabled]="!checkedCheckBox() || !permissionAccessService.check('ATTRIBUTES_MAPPING_DELETE')" (click)="deleteSelected()">
                    <i class="bi bi bi-trash"></i> {{ 'DELETE_SELECTED' | translate }}
                </button>
            </div>

            <div class="modal-body">

                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th scope="col" class="checkbox">
                                <div class="custom-control custom-checkbox">
                                    <input class="custom-control-input" type="checkbox" name="select_template_all"
                                        id="select_template_all" [checked]="isAllCheckBoxChecked()"
                                        [indeterminate]="checkedButNotAllCheckBox()"
                                        (change)="checkAllCheckBox($event)">
                                    <label class="custom-control-label" for="select_template_all"></label>
                                </div>
                            </th>
                            <th scope="col" class="name">{{ 'DENOMINATION' | translate }}</th>
                            <th scope="col" class="type">{{ 'TYPE' | translate }}</th>
                            <th scope="col" class="action">{{ 'ACTION' | translate }}</th>
                        </tr>
                    </thead>

                    <tbody *ngIf="templatesList && templatesList.length > 0">
                        <tr *ngFor="let template of templatesList; let i = index">
                            <td class="checkbox">
                                <div class="custom-control custom-checkbox">
                                    <input class="custom-control-input" type="checkbox" name="select_template_{{ i }}"
                                        id="select_template_{{ i }}" [checked]="template.checked"
                                        (change)="selectedCheckBox(i, $event)">
                                    <label class="custom-control-label" for="select_template_{{ i }}"></label>
                                </div>
                            </td>
                            <td class="name">{{ template.name }}</td>
                            <td class="type">{{ template.type.name }}</td>
                            <td class="action">
                                <button type="button" class="btn btn-light mr-1" (click)="onEdit(template.id)" [disabled]="!permissionAccessService.check('ATTRIBUTES_MAPPING_UPDATE')"
                                    placement="top" ngbTooltip="{{ 'EDIT' | translate }}">
                                    <i class="bi bi-pencil-square"></i>
                                </button>
                                <button type="button" class="btn btn-light" (click)="onConfirm([template.id])" [disabled]="!permissionAccessService.check('ATTRIBUTES_MAPPING_DELETE')"
                                    placement="top" ngbTooltip="{{ 'DELETE' | translate }}">
                                    <i class="bi bi bi-trash"></i>
                                </button>
                            </td>
                        </tr>
                    </tbody>

                    <tbody *ngIf="!templatesList || templatesList.length == 0">
                        <tr>
                            <td *ngIf="loading" class="data-loading" colspan="4">
                                <div class="spinner-bars">
                                    <div class="loadingio-spinner-bars-preLoder-inner">
                                        <div class="preLoder">
                                            <div></div><div></div><div></div><div></div>
                                        </div>
                                    </div>
                                    <div>{{ 'LOADING' | translate }}</div>
                                </div>
                            </td>
                            <td *ngIf="!loading" class="data-not-found" colspan="4">
                                <div>{{ 'DATA_NOT_FOUND' | translate }}</div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="card-footer">
                <app-pagination [pageData]="paginationInput" (pageEvent)="pageEvent($event)"></app-pagination>
            </div>
            <div class="modal-footer btn-box">
                <button type="button" class="btn btn-light btn-sm"   (click)="activeModal.dismiss(false)">{{ 'CLOSE' | translate}}</button>
            </div>
        </div>

    </div>
</div>